import ProxyBase from '../../../core/proxies/ProxyBase'

class ConnectMapProxy extends ProxyBase {
  getSearchCompany(params) {
    return this.post('DomesticSearch/search', params)
  }

  getSearchPerson(params) {
    return this.get('PersonSearch/search', params)
  }

  createConnectionMapLogs(params) {
    return this.post('ConnectionMap/Logs', params)
  }

  updateConnectionMapLogs(params) {
    return this.put('ConnectionMap/Logs', params)
  }

  uploadFileConnectMap(params) {
    return this.post('ConnectionMap/Upload', params, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  upgradeConnectMap(params) {
    return this.post('ConnectionMap/UpgradeRequests', params)
  }

  getPersonDetail(params) {
    return this.get('PersonSearch/GetPerson', params)
  }

  getCompanyDetail(params) {
    return this.get('CompanyProfile/CompanyHeader', params)
  }
}

export default new ConnectMapProxy()
